import { useEffect, useState } from 'react';
import { Confirm } from './types';

const CONFIRM_LIMIT = 5;

type Action =
  | {
      type: 'ADD_CONFIRM';
      confirm: Confirm;
    }
  | {
      type: 'REMOVE_CONFIRM';
      confirmId: string;
    };

interface State {
  confirms: Confirm[];
}

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'ADD_CONFIRM':
      if (state.confirms.find((t) => t.id === action.confirm.id)) {
        return state;
      }
      return {
        ...state,
        confirms: [action.confirm, ...state.confirms].slice(0, CONFIRM_LIMIT),
      };
    case 'REMOVE_CONFIRM':
      return {
        ...state,
        confirms: state.confirms.filter((t) => t.id !== action.confirmId),
      };
    default:
      return state;
  }
};

const listeners: Array<(state: State) => void> = [];

let memoryState: State = { confirms: [] };

export const dispatch = (action: Action) => {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
};

export const useStore = (): State => {
  const [state, setState] = useState<State>(memoryState);
  useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);

  return {
    ...state,
    confirms: state.confirms,
  };
};
